export const LOCALES = {
  ENGLISH: 'en-US',
  KOREAN: 'ko',
};
